'use client';

import { useBadge } from '@/contexts/BadgeContext';

interface NotificationIconProps {
  className?: string;
}

export default function NotificationIcon({ className = '' }: NotificationIconProps) {
  const { badgeCounts } = useBadge();
  
  const totalCount = badgeCounts.totalUnreadCount;
  
  // Don't show the icon if there are no notifications
  if (totalCount === 0) {
    return null;
  }

  return (
    <div className={`relative ${className}`}>
      {/* Bell Icon */}
      <svg 
        className="w-6 h-6 text-current" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" 
        />
      </svg>
      
      {/* Badge Count */}
      <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">
        {totalCount > 99 ? '99+' : totalCount}
      </span>
    </div>
  );
}